module.exports = __webpack_public_path__ + "img/kwt.496fa466.svg";